import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover'
import { DatePickerProps, DatePickerMode } from './types'
import { DEFAULT_PLACEHOLDER } from './constants'

export { DatePickerMode }
import { useDatePicker } from './hooks/useDatePicker'
import {
  DatePickerTrigger,
  PresetSelect,
  ConfirmButton,
  DatePickerCalendar,
} from './components'

export default function DatePicker({
  value,
  onChange,
  placeholder = DEFAULT_PLACEHOLDER,
  className = '',
  hasError = false,
  disabled = false,
  mode = DatePickerMode.Single,
}: DatePickerProps) {
  const {
    open,
    setOpen,
    tempDate,
    tempRange,
    presetSelectValue,
    presetSelectLabel,
    handlePresetChange,
    handleSelectSingle,
    handleSelectRange,
    handleConfirm,
    formatDisplayValue,
  } = useDatePicker(value, onChange, mode, placeholder)

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <DatePickerTrigger
          displayValue={formatDisplayValue()}
          open={open}
          disabled={disabled}
          hasError={hasError}
          className={className}
        />
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        {mode === DatePickerMode.Range && (
          <PresetSelect
            value={presetSelectValue}
            displayLabel={presetSelectLabel}
            onValueChange={handlePresetChange}
          />
        )}
        <DatePickerCalendar
          mode={mode}
          tempDate={tempDate}
          tempRange={tempRange}
          onSelectSingle={handleSelectSingle}
          onSelectRange={handleSelectRange}
        />
        <ConfirmButton onConfirm={handleConfirm} />
      </PopoverContent>
    </Popover>
  )
}
